import { render, staticRenderFns } from "./TakeCourseTab.vue?vue&type=template&id=e7f15e0a&"
import script from "./TakeCourseTab.vue?vue&type=script&setup=true&lang=ts&"
export * from "./TakeCourseTab.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports